import React from "react";
import dollars from '../../dollar-format';
import {percent} from '../../utils';
import arrowRed from "../../svgs/arrow-red.svg";
import arrowGreen from "../../svgs/arrow-green.svg";
import { reportTypes } from "../../consts/consts";

const rows = [{
    name: 'No. of Transactions',
    key: 'COUNT'
}, {
    name: 'Ave Price',
    key: 'PRICE',
    formatType: '$',
}, {
    name: 'Ave Cap Rate',
    key: 'CAP_RATE',
    formatType: '%',
    decimals: 2
}, {
    name: 'Ave Cap Rate at List',
    key: 'LIST_CAP_RATE',
    formatType: '%',
    decimals: 2
}, {
    name: 'Delta (List to Sell)',
    key: 'DELTA_LIST_TO_SELL',
    formatType: 'bps',
}, {
    name: 'Ave PSF',
    key: 'PRICE_PSF',
    formatType: '$',
}, {
    name: 'Ave Rent PSF',
    key: 'RENT_PSF',
    formatType: '$',
}, {
    name: 'Occupancy',
    key: 'OCCUPANCY',
    formatType: '%',
    decimals:1
}];

export default class MarketReport extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            query: {},
            year: null,
            previousYear:null,
            transactions: {
                STNL: {},
                MT: {}
            },
            isPrint: false,
            printBackground: '',
        };

        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
    }

    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

    static formatValue({data, key, formatType, decimals, reportType}) {
        let value = data[key] || 0;
        let prevValue = data[`${key}_FIRST_COL`] || 0;
        let delta = data[`${key}_DELTA`] || 0;
        if (delta < 0) delta = Math.abs(delta).toString();
        let deltaPercent = data[`${key}_DELTA_PERCENT`] ? Math.round(data[`${key}_DELTA_PERCENT`]) : 0;

        switch (formatType) {
            case '$': {
                value = dollars(value);
                prevValue = dollars(prevValue);
                delta = dollars(delta);
                break;
            }
            case '%': {
                value = percent(value, decimals);
                prevValue = percent(prevValue, decimals);
                delta = ['CAP_RATE','LIST_CAP_RATE','OCCUPANCY'].includes(key) ? percent(delta, 1) : percent(delta);          
                break;
            }
            case 'bps': {
                if (key === 'DELTA_LIST_TO_SELL') {
                    if (parseFloat(value) < 0) value = Math.abs(value* 100).toFixed(decimals || 0) + ' bps';
                    else value = Number(value * 100).toFixed(decimals || 0)  + ' bps';
                    if (parseFloat(prevValue) < 0) prevValue = Math.abs(prevValue).toFixed(decimals || 0) + ' bps';
                    else prevValue = Number(prevValue* 100).toFixed(decimals || 0) + ' bps';
                }
            }
        }

        if (deltaPercent < 0) deltaPercent = Math.abs(deltaPercent).toString();
        deltaPercent = percent(deltaPercent);

        if (key === 'DELTA_LIST_TO_SELL')
            return {value, prevValue, delta: '', deltaPercent: ''};

        if (key === 'COUNT' && reportType === reportTypes.MarketShare) {
            deltaPercent = percent(value/prevValue*100, 1);
            return {value, prevValue, delta: '', deltaPercent};
        }
        return {value, prevValue, delta, deltaPercent};
    }

    static buildTableData({prevData, data, type}) {
        const transactions = {};
        rows.forEach(row => {
            if (type === 'STNL' && row.key === 'OCCUPANCY') return;

            let value = data[row.key] || 0;
            let prevValue = prevData[row.key] || 0;
            let delta = data[row.key] - prevData[row.key] || 0;

            if (row.key === 'PRICE')  {
                value = parseInt(value);
                prevValue = parseInt(prevValue);
                delta = parseInt(delta);
            }

            transactions[row.key] = value;
            transactions[`${row.key}_FIRST_COL`] = prevValue;

            if (row.key !== 'DELTA_LIST_TO_SELL') {
                transactions[`${row.key}_DELTA`] = delta;
                transactions[`${row.key}_DELTA_PERCENT`] = prevValue ? (value - prevValue) / prevValue * 100 : value * 100;
            }
        });
        return transactions;
    }
    
    static renderMarketTable({reportType, data, type, market, year, previousYear, baseMin, baseMax}) {        
        const baseMinMD = baseMin ? baseMin.split('/')[0] + '/'+ baseMin.split('/')[1] : '';
        const baseMaxMD = baseMax ? baseMax.split('/')[0] + '/'+ baseMax.split('/')[1] : '';

        return (
            <React.Fragment>
                <div className='texas-market-title'>{type} Type</div>
                <div className='texas-market-subtitle'>TRANSACTIONS IN {market ? market : 'Texas'}</div>
                {reportType === reportTypes.MarketTransactionBreakdown &&
                    <div className='texas-market-subtitle small'>{baseMinMD} - {baseMaxMD}</div>
                }
                <table className='texas-market-table'>
                    <thead>
                    <tr className='texas-market-tr'>
                        <th className='texas-market-th'/>
                        <th className='texas-market-th'>{reportType === reportTypes.MarketShare ? year : previousYear}</th>
                        <th className='texas-market-th'>{reportType === reportTypes.MarketShare ? 'SUMMIT' : year}</th>
                        <th className='texas-market-th'>Delta</th>
                        <th className='texas-market-th'>% △</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        rows.map((row, index) => {
                            if (type === 'Single-Tenant' && row.key === 'OCCUPANCY') return;

                            const {prevValue, value, delta, deltaPercent} = data ? MarketReport.formatValue({data, key: row.key, formatType: row.formatType, decimals:row.decimals, reportType}) : '';
                            const negative = reportType === reportTypes.MarketShare && row.key === 'COUNT' ? false : data[`${row.key}_DELTA`] < 0;
                            const showArrow = reportType === reportTypes.MarketShare ? row.key !== 'COUNT' : true;
                            return (
                                <tr key={index} className='texas-market-tr'>
                                    <td className={`texas-market-td ${index % 2 ? 'second-color' : ''}`}>{row.name}</td>
                                    <td className={`texas-market-td ${index % 2 ? 'second-color' : ''}`}>{prevValue}</td>
                                    <td className={`texas-market-td ${index % 2 ? 'second-color' : ''}`}>{value}</td>
                                    <td className={`texas-market-td ${index % 2 ? 'second-color' : ''} ${negative ? 'red' : 'green'}`}>{delta}</td>
                                    <td className={`texas-market-td ${index % 2 ? 'second-color' : ''} ${negative ? 'red' : 'green'}`}>
                                        {
                                            deltaPercent &&
                                            <div className='texas-market-delta-percent'>
                                                {deltaPercent}
                                                { showArrow &&
                                                    <div className={negative ? 'arrow-red' : 'arrow-green'} dangerouslySetInnerHTML={{__html: negative ? arrowRed : arrowGreen}}/>}
                                            </div>
                                        }
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </React.Fragment>
        )
    }

}